export default "__VITE_ASSET__8uv2bbxw__"